export type ActionFilter = { display: string; value: string | undefined };

export const PartTransactionConfigMachine = "machine";
export const PartTransactionConfigPartOrder = "partOrder";
export const PartTransactionConfigPartLocation = "partLocation";
export const PartTransactionConfigAll = "all";

export function buildTransactionComponentConfig(
  config: Partial<
    PartTransactionComponentFilters & { actionGroupNames: string[] }
  >,
): PartTransactionComponentConfig {
  const actionFilters = (config.actionGroupNames ?? []).reduce(
    (result, current) => {
      result.push(...PartTransactionComponentActionFilterGroups[current]);
      return result;
    },
    <ActionFilter[]>[],
  );

  return {
    actionFilters,
    showMachineFilter: config.showMachineFilter ?? false,
    showPartOrderFilter: config.showPartOrderFilter ?? false,
    showPartRoomFilter: config.showPartRoomFilter ?? false,
  };
}

export const PartTransactionComponentActionFilterGroups: Record<
  string,
  ActionFilter[]
> = {
  [PartTransactionConfigMachine]: [
    {
      display: "Machine Part Add",
      value: "MachinePartAdd",
    },
    {
      display: "Machine Part Recovery",
      value: "MachinePartRecovery",
    },
  ],
  [PartTransactionConfigPartOrder]: [
    {
      display: "Part Order Item Distribute",
      value: "PartOrderItemDistribute",
    },
  ],
  [PartTransactionConfigPartLocation]: [
    { display: "Parts Check In", value: "PartsCheckIn" },
    { display: "Parts Check Out", value: "PartsCheckOut" },
    { display: "Part Locations Save", value: "PartLocationsSave" },
    { display: "Parts Retire", value: "PartsRetire" },
    { display: "Repair Part", value: "Repair Part" },
  ],
};

PartTransactionComponentActionFilterGroups[PartTransactionConfigAll] =
  Object.values(PartTransactionComponentActionFilterGroups).flatMap((g) => g);

export const EmptyConfig: PartTransactionComponentConfig = {
  actionFilters: [],
  showMachineFilter: false,
  showPartOrderFilter: false,
  showPartRoomFilter: false,
};

export const AllConfig: PartTransactionComponentConfig =
  buildTransactionComponentConfig({
    actionGroupNames: [PartTransactionConfigAll],
    showMachineFilter: true,
    showPartOrderFilter: true,
    showPartRoomFilter: true,
  });

type PartTransactionComponentFilters = {
  showMachineFilter: boolean;
  showPartOrderFilter: boolean;
  showPartRoomFilter: boolean;
};

export type PartTransactionComponentConfig = PartTransactionComponentFilters & {
  actionFilters: ActionFilter[];
};
